const $ = jQuery.noConflict();
/* eslint-disable */
'use strict';

const CustomOrder = {

	init: function() {
		if ($('body.woocommerce-checkout').length > 0) {
			return false;
		}
		$('#billing_country').on('change', function() {
			CustomOrder.getCountryStates();
			if ($('#billing_state').val()) {
				$('#billing_state').parent().parent().find('label').addClass('is-moved');
			} else {
				$('#billing_state').parent().parent().find('label').removeClass('is-moved');
			}
			if ($('#billing_country').length) {
				if ($('#billing_country').val()) {
					$('#billing_country').parent().parent().find('label').addClass('is-moved');
				}
			}
			if ($('#billing_city').length) {
				if ($('#billing_city').val()) {
					$('#billing_city').parent().parent().find('label').addClass('is-moved');
				} else {
					$('#billing_city').parent().parent().find('label').removeClass('is-moved');
				}
			}
		});
		$('#billing_address_1').on('change', function() {
			CustomOrder.getCountryStates();
			if ($('#billing_state').val()) {
				$('#billing_state').parent().parent().find('label').addClass('is-moved');
			} else {
				$('#billing_state').parent().parent().find('label').removeClass('is-moved');
			}
			if ($('#billing_country').length) {
				if ($('#billing_country').val()) {
					$('#billing_country').parent().parent().find('label').addClass('is-moved');
				}
			}
			if ($('#billing_city').val()) {
				$('#billing_city').parent().parent().find('label').addClass('is-moved');
			} else {
				$('#billing_city').parent().parent().find('label').removeClass('is-moved');
			}
		});
		if ($('#billing_country').val()) {
			$('#billing_country').parent().parent().find('label').addClass('is-moved');
		}
		$('#billing_country').parent().parent().find('label').addClass('is-moved');
		$('.js-single-product__slider-upper-link').on('click', function() {
			setTimeout(function() {
				$('#billing_country').val('US').trigger('change');
			}, 600);
		});
	},

	getCountryStates: function() {
		let selectedCountry = $('#billing_country').val(); // Get selected country code
		let stateDropdown = $('#billing_state');

		// stateDropdown.html('<option>Loading...</option>');

		$.ajax({
			url: window.fwsLocalized.ajaxUrl, // WordPress AJAX URL
			type: 'POST',
			data: {
				action: 'cf7_get_states',
				country_name: selectedCountry,
			},
			success: function(response) {
				stateDropdown.empty();
				if (response.success && Object.keys(response.data).length) {
					// Set the placeholder as disabled and selected
					stateDropdown.append('<option value="" disabled selected>Select State</option>');
					$.each(response.data, function(code, name) {
						stateDropdown.append(`<option value="${code}">${name}</option>`);
					});
					if ($('#billing_state').length) {
						if ($('#billing_state').val()) {
							$('#billing_state').parent().parent().find('label').addClass('is-moved');
						} else {
							$('#billing_state').parent().parent().find('label').removeClass('is-moved');
						}
					}
					if ($('#billing_postcode').length) {
						if ($('#billing_postcode').val()) {
							$('#billing_postcode').parent().parent().find('label').addClass('is-moved');
						} else {
							$('#billing_postcode').parent().parent().find('label').removeClass('is-moved');
						}
					}
					if ($('#billing_country').length) {
						if ($('#billing_country').val()) {
							$('#billing_country').parent().parent().find('label').addClass('is-moved');
						}
					}
					if ($('#billing_city').val()) {
						$('#billing_city').parent().parent().find('label').addClass('is-moved');
					} else {
						$('#billing_city').parent().parent().find('label').removeClass('is-moved');
					}
				} else {
					stateDropdown.append('<option>No states available</option>');
					if ($('#billing_state').length) {
						if ($('#billing_state').val()) {
							$('#billing_state').parent().parent().find('label').addClass('is-moved');
						} else {
							$('#billing_state').parent().parent().find('label').removeClass('is-moved');
						}
					}
					if ($('#billing_postcode').length) {
						if ($('#billing_postcode').val()) {
							$('#billing_postcode').parent().parent().find('label').addClass('is-moved');
						} else {
							$('#billing_postcode').parent().parent().find('label').removeClass('is-moved');
						}
					}
					if ($('#billing_country').length) {
						if ($('#billing_country').val()) {
							$('#billing_country').parent().parent().find('label').addClass('is-moved');
						} else {
							$('#billing_country').parent().parent().find('label').removeClass('is-moved');
						}
					}
					if ($('#billing_city').val()) {
						$('#billing_city').parent().parent().find('label').addClass('is-moved');
					} else {
						$('#billing_city').parent().parent().find('label').removeClass('is-moved');
					}
				}
			},
			error: function() {
				stateDropdown.html('<option>Error loading states</option>');
			},
		});
	}
}

export default CustomOrder;
